import superagent from "superagent";
import {authorize} from "../../helper/authorize-token";


const calcCategoryAllocation = (token, total_portfolio_years, risk, portfolio_time) => {
  return new Promise((resolve) => {
    return superagent.agent()
      .post("/api/dashboard/calc-category-allocation")
      .send({ total_portfolio_years, risk, portfolio_time })
      .use(authorize(token))
      .then(result => {
        resolve(result.body.data);
      });
  })
}

const getLastCategoryAllocation = (token, username, index) => {
  return new Promise(resolve => {
    return superagent.agent()
      .post("/api/dashboard/get-last-category-allocation")
      .send({ username, index })
      .use(authorize(token))
      .then(result => {
        resolve(result.body);
      });
  })
}

const calcSecurityAllocation = (
  token, category_allocation, amt_usd, current_security_alloc, cash_alloc_cap, username, index,
  ignore_securities) => {
  return new Promise((resolve) => {
    return superagent.agent()
      .post("/api/dashboard/calc-security-allocation")
      .send({ category_allocation, amt_usd, current_security_alloc,
        cash_alloc_cap, username, index, ignore_securities })
      .use(authorize(token))
      .then(result => {
        resolve(result.body.data);
      });
  })
}

const calcMTWAllocation = (
  token, username, index, cash_alloc_cap) => {
  return new Promise((resolve) => {
    return superagent.agent()
      .post("/api/dashboard/calc-MTW-allocation")
      .send({ username, index, cash_alloc_cap })
      .use(authorize(token))
      .then(result => {
        resolve(result.body);
      });
  })
}

export {
  calcCategoryAllocation, calcSecurityAllocation, getLastCategoryAllocation,
  calcMTWAllocation };
